import React, { useState } from 'react';
import { useSelector } from 'react-redux'
import clsx from 'clsx'

import { IInputWrapperWithLabelProps, InputFactoryProps } from './InputFactoryProps'
import { FieldTypes } from 'models/Form/FieldsModels'
import InputText from '../InputText/InputText'
import useInputFactoryLogic from './hooks/useInputFactoryLogic'
import { AppState } from 'store'
import InputNumber from '../InputNumber/InputNumber'
import InputDate from '../InputDate/InputDate'
import InputTextAutocomplete  from '../InputTextAutocomplete/InputTextWithAutocomplete'


import '../InputBaseStyles.scss'


const InputWrapperWithLabel = (props: IInputWrapperWithLabelProps) => {
   return (
      <div className={clsx('form-input-base-container', props.hasError && props.fieldErrorClassName, props.fullWidthInput && 'full-width-input')}>
         <label 
            htmlFor={props.name as string} 
            className={clsx(props.hasInputFocused && 'form-input-base-filled')}
            >
            {props.label}
         </label>
         {props.children}
      </div>
   )
}

const InputFactory = (props: InputFactoryProps) => {
   const INPUT_DEBOUNCE_TIME = 500
   const currentFieldData = useSelector((state: AppState) => state.formState[props.field.name])

   const [hasInputFocused, setHasInputFocused] = useState<boolean>(false)
   const { handleSaveInputValueToState, handleValidateField, handleOnPasteDisabled, handleSetIsFieldFirstFill, fieldErrorClassName } = useInputFactoryLogic()
   const { field } = props

   switch(field.type) {
      case FieldTypes.string: {
         return (
            <InputWrapperWithLabel 
               name={field.name} 
               label={field.label}
               hasInputFocused={hasInputFocused} 
               hasError={Boolean(currentFieldData.validationError?.length)}
               fieldErrorClassName={fieldErrorClassName}
               fullWidthInput={field.fullWidthInput}
            >
               <InputText
                  value={currentFieldData.value}
                  debounceTime={INPUT_DEBOUNCE_TIME} 
                  setHasInputFocused={setHasInputFocused} 
                  field={field}
                  handleSetIsFieldFirstFill={handleSetIsFieldFirstFill}
                  isFirstFill={currentFieldData.isFirstFill}
                  handleSaveInputValueToState={handleSaveInputValueToState}
                  handleValidateField={handleValidateField}
                  handlePasteDisabled={handleOnPasteDisabled}
               />
               <p className='form-input-base-error-helper-text'>{currentFieldData.validationError}</p>
            </InputWrapperWithLabel> 
         )
      }
            case FieldTypes.stringAutocomplet: {
               return (
                  <InputWrapperWithLabel 
                     name={field.name} 
                     label={field.label}
                     hasInputFocused={hasInputFocused} 
                     hasError={Boolean(currentFieldData.validationError?.length)}
                     fieldErrorClassName={fieldErrorClassName}
                     fullWidthInput={field.fullWidthInput}
                  >
                     <InputTextAutocomplete
                        value={currentFieldData.value}
                        debounceTime={INPUT_DEBOUNCE_TIME} 
                        setHasInputFocused={setHasInputFocused} 
                        field={field}
                        handleSetIsFieldFirstFill={handleSetIsFieldFirstFill}
                        isFirstFill={currentFieldData.isFirstFill}
                        handleSaveInputValueToState={handleSaveInputValueToState}
                        handleValidateField={handleValidateField}
                        handlePasteDisabled={handleOnPasteDisabled}
                     />
                     <p className='form-input-base-error-helper-text'>{currentFieldData.validationError}</p>
                  </InputWrapperWithLabel> 
               )
            }
      case FieldTypes.number: {
         return (
            <InputWrapperWithLabel 
               name={field.name} 
               label={field.label}
               hasInputFocused={hasInputFocused} 
               hasError={Boolean(currentFieldData.validationError?.length)}
               fieldErrorClassName={fieldErrorClassName}
               fullWidthInput={field.fullWidthInput}
            >
               <InputNumber
                  value={currentFieldData.value}
                  debounceTime={INPUT_DEBOUNCE_TIME} 
                  setHasInputFocused={setHasInputFocused} 
                  field={field}
                  handleSetIsFieldFirstFill={handleSetIsFieldFirstFill}
                  isFirstFill={currentFieldData.isFirstFill}
                  handleSaveInputValueToState={handleSaveInputValueToState}
                  handleValidateField={handleValidateField}
                  handlePasteDisabled={handleOnPasteDisabled}
               />
               <p className='form-input-base-error-helper-text'>{currentFieldData.validationError}</p>
            </InputWrapperWithLabel> 
         )
      }
      case FieldTypes.date: {
         return (
            <InputWrapperWithLabel 
               name={field.name} 
               label={field.label} 
               hasInputFocused={hasInputFocused} 
               hasError={Boolean(currentFieldData.validationError?.length)}
               fieldErrorClassName={fieldErrorClassName}
               fullWidthInput={field.fullWidthInput}
            >
               <InputDate
                  value={currentFieldData.value}
                  debounceTime={INPUT_DEBOUNCE_TIME} 
                  setHasInputFocused={setHasInputFocused} 
                  field={field}
                  handleSetIsFieldFirstFill={handleSetIsFieldFirstFill}
                  isFirstFill={currentFieldData.isFirstFill}
                  handleSaveInputValueToState={handleSaveInputValueToState}
                  handleValidateField={handleValidateField}
               />
               <p className='form-input-base-error-helper-text'>{currentFieldData.validationError}</p>
            </InputWrapperWithLabel> 
         )
      }
      default: {
         return <input type="hidden" />
      }
   }
}

export default InputFactory
